import { render, staticRenderFns } from "./Vietnam.vue?vue&type=template&id=7360e5fe&scoped=true&"
import script from "./Vietnam.vue?vue&type=script&lang=js&"
export * from "./Vietnam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7360e5fe",
  null
  
)

export default component.exports